import { Toast } from 'primereact/toast';

export const ShowToast = (
  toast: React.RefObject<Toast>,
  severity: 'success' | 'info' | 'warn' | 'error',
  summary: string,
  detail: string,
  life: number = 3000
) => {
  toast.current?.show({
    severity,
    summary,
    detail,
    life,
  });
};